"use strict";

exports.__esModule = true;
var _ReportList = require("./ReportList");
Object.keys(_ReportList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportList[key]) return;
  exports[key] = _ReportList[key];
});